function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M16.4 3.6V18c-.2-.1-.3-.3-.5-.4-.3-.3-1.1-.9-2.4-1.2 0 0-.4-.1-.5-.1H3.6s-.1 0-.1-.1V3.7s0-.1.1-.1h12.8zm0-3.6H3.6C1.6 0 0 1.6 0 3.7v12.5c0 2 1.7 3.7 3.7 3.7h9c.6.1.9.4 1.1.6 1.4 1.1 4.2 3.2 4.2 3.2.2.2.7.3.9.3h.2c.6 0 1-.4 1-1V3.7C20 1.7 18.4 0 16.4 0z",
  fillRule: "nonzero",
  fill: "#231F20"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 24,
    viewBox: "0 0 21 24"
  }, props), _ref);
};

export default SvgComponent;